import type { SeamGround } from "daedalus-core";
import { groundSurface } from "../ground/surfaces.ts";

/**
 * The classes of ground OdysseyTales gives the seam continuity check (ADR-109 decision 6, P1.6-T152). They are read
 * from a terrain's name, as the surface of a footstep is: a name holding a word of a wall is blocked, then one
 * holding a word of a way is a path, then one whose surface is water is water; any other terrain is open ground.
 */

const BLOCKED_WORDS: readonly string[] = ["cliff", "wall", "dyke", "dike", "fence", "hedge"];

const PATH_WORDS: readonly string[] = ["path", "road", "lane", "track", "trail"];

/**
 * The class of ground of a terrain.
 *
 * @param terrain The terrain's id and name.
 * @returns `blocked`, `path` or `water`, or undefined for open ground.
 */
export function seamGroundOf(terrain: { readonly id: string; readonly name: string }): SeamGround | undefined {
  const name = terrain.name.toLowerCase();
  if (BLOCKED_WORDS.some((word) => name.includes(word))) {
    return "blocked";
  }
  if (PATH_WORDS.some((word) => name.includes(word))) {
    return "path";
  }
  return groundSurface(name) === "water" ? "water" : undefined;
}
